import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SetComponentLanguage } from '../../../helpers';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './ConfirmDeleteEventModal.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class ConfirmDeleteEventModal extends Component {

	render() {
	  	return (
			<div>
		  		<Modal isOpen={this.props.isDeleteEventOpen} toggle={this.props.toggleConfirmDeleteEvent}>
		          	<ModalHeader toggle={this.props.toggleConfirmDeleteEvent}>{strings.title}</ModalHeader>
		          	<ModalBody>
					  	{strings.description}
		          	</ModalBody>
		          	<ModalFooter className="justify-content-center">
		            	<button 
		            		className="showtix-button showtix-background__grey-1"
                            onClick={this.props.toggleConfirmDeleteEvent}
		            		>{strings.cancel}</button>
                        <button 
		            		className="showtix-button showtix-background__primary-3"
                            onClick={this.props.confirmConfirmDeleteEvent}
		            		>{strings.delete}</button>    
		          	</ModalFooter>
		        </Modal>
			</div>
	  	);
	}
}

ConfirmDeleteEventModal.propTypes = {
    isDeleteEventOpen: PropTypes.bool,
    toggleConfirmDeleteEvent: PropTypes.func,
    confirmConfirmDeleteEvent: PropTypes.func,
}

export default ConfirmDeleteEventModal;


// WEBPACK FOOTER //
// ./src/components/Common/ConfirmDeleteEventModal/ConfirmDeleteEventModal.js